export const CONSTANT_0 = 0
export const CONSTANT_1 = 1
export const CONSTANT_2 = 2
export const CONSTANT_3 = 3
export const CONSTANT_99 = 99
export const accompanyTypeHasNum = [CONSTANT_2, CONSTANT_3] // 1-家人 2-朋友
// 性别
export const genderMap = new Map([
  [CONSTANT_1, '男'],
  [CONSTANT_2, '女']
])
export const genderList = Array.from(genderMap, ([value, name]) => ({label: name, value}))

//  条件选择 --- 是否预约/是否置换
export const conditionSelectionMap = new Map([
  // [CONSTANT_0, '全部'],
  [CONSTANT_1, '是'],
  [CONSTANT_2, '否'],
])
export const conditionSelectionList = Array.from(conditionSelectionMap, ([value, name]) => ({label: name, value}))

// 付款方式
export const payTypeMap = new Map([
  [CONSTANT_1, '按揭'],
  [CONSTANT_2, '全款'],
])
export const payTypeList = Array.from(payTypeMap, ([value, name]) => ({label: name, value}))

// 状态
export const StatusMap = new Map([
  [CONSTANT_0, '全部'],
  [CONSTANT_1, '接待中'],
  [CONSTANT_2, '已接待'],
])
export const statusList = Array.from(StatusMap, ([value, name]) => ({label: name, value}))

export const datePickerOption = {
  firstDayOfWeek: 1,
  // shortcuts: [
  //   {
  //     text: "今日",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       picker.$emit("pick", [start, end])
  //     }
  //   },
  //   {
  //     text: "昨日",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
  //       end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
  //       picker.$emit("pick", [start, end])
  //     }
  //   },
  //   {
  //     text: "最近一周",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
  //       picker.$emit("pick", [start, end])
  //     }
  //   },
  //   {
  //     text: "最近一个月",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
  //       picker.$emit("pick", [start, end])
  //     }
  //   },
  //   {
  //     text: "最近三个月",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
  //       picker.$emit("pick", [start, end])
  //     }
  //   },
  //   {
  //     text: "最近一年",
  //     onClick(picker) {
  //       const end = new Date()
  //       const start = new Date()
  //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 364)
  //       picker.$emit("pick", [start, end])
  //     }
  //   }
  // ]
}

// 客流类型
export const customerFlowTypeMap = new Map([
  [CONSTANT_0, '全部'],
  [CONSTANT_1, '接待中'],
  [CONSTANT_2, '已接待'],
])
export const customerFlowTypeList = Array.from(customerFlowTypeMap, ([value, name]) => ({label: name, value}))

// 登记类型
export const registerTypeMap = new Map([
  [CONSTANT_1, '到店登记'],
  [CONSTANT_2, '离店登记'],
])

const formatDateString = (str) => {
  if (typeof str !== 'string' && typeof str !== 'number') {
    throw new Error('Invalid input type. Expected string or number.');
  }
  return String(str).padStart(2, '0')
}

export const getDateTime = (time) => {
  const date = time ? new Date(time): new Date()
  const year = formatDateString(date.getFullYear())
  const month = formatDateString(date.getMonth() + 1)
  const day = formatDateString(date.getDate())
  const hour = formatDateString(date.getHours());
  const minute = formatDateString(Math.floor(date.getMinutes() / 5) * 5);
  return {
    date: `${year}-${month}-${day}`,
    moment: `${hour}:${minute}`
  }
}

